// WARNING: DO NOT EDIT. This file is automatically generated.

const awsConfig = {
    "region": "eu-central-1",
    "stage": "staging",
    "accountName": "wow",
    "api_url": "https://7yn47p42nh.execute-api.eu-central-1.amazonaws.com/staging/graphql",
    "notifications_api_url": "https://7yn47p42nh.execute-api.eu-central-1.amazonaws.com/staging/notifications",
    "run_daily_test_url": "https://w8dbtupkag.execute-api.eu-central-1.amazonaws.com/staging/run-daily-test",
    "sport_highlights_url": "https://7qxlbenunjf6hcl64snw2qlbwu.appsync-api.eu-central-1.amazonaws.com/graphql",
    "appconfig_url": "https://7yn47p42nh.execute-api.eu-central-1.amazonaws.com/staging/getConfig",
    "direct_appconfig_url": "https://b7x7uklsl9.execute-api.eu-central-1.amazonaws.com/staging",
		"endpoint_url" : "https://7yn47p42nh.execute-api.eu-central-1.amazonaws.com/staging",
    "mgmt_ui_appconfig_dropdown_profile": "mgmt-ui-dropdown-options",
    "mgmt_ui_appconfig_configs_profile": "mgmt-ui-configs",
    "daily-test-game-configs": "daily-testing-configs",
    "leagues": "leagues",
    "aws_project_region": "eu-central-1",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_0madgdMxd",
    "aws_user_pools_web_client_id": "5stvg85tj0jbio8jr87opn3vtj",
    "oauth": {
        "domain": "spex-mgmt-ui-hosting-staging.auth.eu-central-1.amazoncognito.com",
        "scope": [
          "phone",
          "email",
          "profile",
          "openid",
          "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://mgmt.staging.wow.aidisco.sky.com",
        "redirectSignOut": "https://mgmt.staging.wow.aidisco.sky.com",
        "responseType": "code"
    },
    "defaultChannelName": "ExternalSLE",
    "playfactoryLicenseAcquisitionEndpointUrl": "https://9e6loi83ge.execute-api.eu-central-1.amazonaws.com/staging",
    "arcusLicenseAcquisitionEndpointUrl": "https://rf0aa5go8j.execute-api.eu-central-1.amazonaws.com/staging",
    "viperProxyUrl": ""
};

export default awsConfig;

